import { useMutation } from 'react-query';
import {
  createResponsibleRecognitionAsync,
  getAllResponsibleByLicenseAsync,
  getAllResponsiblesForSelectionAsync,
  getResponsibleRecognitionByIdAsync,
  updateResponsibleRecognitionAsync,
} from '../../index';

export const useCreateResponsibleRecognitionAsync = () =>
  useMutation(createResponsibleRecognitionAsync);

export const useUpdateResponsibleRecognitionAsync = () =>
  useMutation(updateResponsibleRecognitionAsync);

export const useGetResponsibleRecognitionByIdAsync = () =>
  useMutation(getResponsibleRecognitionByIdAsync);

export const useGetAllResponsibleByLicenseMutateAsync = () =>
  useMutation(getAllResponsibleByLicenseAsync);

export const useGetAllResponsiblesForSelectionMutateAsync = () => {
  return useMutation(getAllResponsiblesForSelectionAsync);
};
